import { render, staticRenderFns } from "./RedeemPromotionDetail.vue?vue&type=template&id=343a83a8&scoped=true&"
import script from "./RedeemPromotionDetail.vue?vue&type=script&lang=js&"
export * from "./RedeemPromotionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343a83a8",
  null
  
)

export default component.exports